export default "__VITE_PUBLIC_ASSET__ca85a5ea__"